import { render, staticRenderFns } from "./GoodsOptionsModal.vue?vue&type=template&id=64ef7395&scoped=true"
import script from "./GoodsOptionsModal.vue?vue&type=script&lang=js"
export * from "./GoodsOptionsModal.vue?vue&type=script&lang=js"
import style0 from "./GoodsOptionsModal.vue?vue&type=style&index=0&id=64ef7395&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64ef7395",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\JSH_ERP\\JSH_ERP\\mgerpweb\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('64ef7395')) {
      api.createRecord('64ef7395', component.options)
    } else {
      api.reload('64ef7395', component.options)
    }
    module.hot.accept("./GoodsOptionsModal.vue?vue&type=template&id=64ef7395&scoped=true", function () {
      api.rerender('64ef7395', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/plugin/dining/cashier/GoodsOptionsModal.vue"
export default component.exports